import { makeStyles } from 'tss-react/mui';

const useStylesControlButton: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  controlButton: {
    width: 150,
    color: theme.palette.common.white,
    border: `1px solid ${theme.palette.common.white} !important`,
    '&:last-of-type': {
      marginLeft: '10px !important',
    },
  },
  controlButtonModal: {
    width: '100px !important',
    '&:last-of-type': {
      marginLeft: 20,
    },
    [theme.breakpoints.down('md')]: {
      marginTop: 5,
    },
  },
  controlButtonActive: {
    '&:hover, &:active': {
      color: `${theme.palette.common.black} !important`,
    },
  },
  controlButtonDisabled: {
    backgroundColor: `${theme.palette.action.disabled} !important`,
    color: `${theme.palette.common.white} !important`,
  },
  controlButtonIcon: {
    padding: '5px 8px !important',
    [theme.breakpoints.down('md')]: {
      minWidth: 50,
    },
  },
  controlButtonIconLabel: {
    marginLeft: 0,
    '&:last-of-type': {
      width: 70,
    },
    [theme.breakpoints.down('lg')]: {
      display: 'none',
    },
  },
}));

export default useStylesControlButton;
